module.exports = __webpack_public_path__ + "static/media/auto-clicker-particles.71c2caef.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/views/pages/kohi-click-test/auto-clicker-particles.jpg
 ** module id = 575
 ** module chunks = 0
 **/